import initToggle from "./toggle";
import { snazzyMapStyle } from "./constants";

const centerCoords = {
  DESKTOP_CENTER: { lat: 59.9486403, lng: 30.3406835 }, // lat: 59.9676403, lng: 30.2806835
  MOBILE_CENTER: { lat: 59.9486403, lng: 30.3499835 },
};
const windowWidth = window.innerWidth; //TODO: optimize window width usage
const descktopZoom = windowWidth < 1440 ? 12.7 : 13.1;
const mobileZoom = 12;
let zoom = null;

export default (isMobile, locale) => {
  const initMap = () => {
    zoom = isMobile ? mobileZoom : descktopZoom;

    const style = snazzyMapStyle;
    const mainPageOptions = {
      styles: snazzyMapStyle,
      zoom: zoom,
      center: isMobile
        ? centerCoords.MOBILE_CENTER
        : centerCoords.DESKTOP_CENTER,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      disableDefaultUI: true,
      draggable: false,
      clickableIcons: false,
      zoomControl: 560 < windowWidth,
    };
    const map = new google.maps.Map(
      document.getElementById(`map`),
      mainPageOptions,
    );
    const CustomMarker = generateCustomMarker();
    const markers = [];
    const mainMarker = new CustomMarker(
      new google.maps.LatLng(59.9486403, 30.34068358),
      map,
      {
        isTexted: true,
        markerClassName: `place__marker place__marker--main ${windowWidth < 560 ? `place__marker--folded` : ``}`,
        title: {
          ru: `Особняк<br>Кушелева-Безбородко`,
          en: `The Kushelev-Bezborodko Mansion`,
          cn: `库舍列夫-别兹博罗德科独家住宅`,
        },
        address: {
          ru: `наб. Кутузова, 24`,
          en: `24 Kutuzov Embankment`,
          cn: `库图佐夫堤岸24号`,
        },
      },
    );
    const summerGarden = new CustomMarker(
      new google.maps.LatLng(59.9449379, 30.33548799999994),
      map,
      {
        isTexted: true,
        markerClassName: `place__marker place__marker--folded place__marker--optional place__marker--summer place__marker--hidden`,
        title: {
          ru: `Летний сад`,
          en: `Summer Garden (Letny Sad)`,
          cn: `夏花园`,
        },
        address: {
          ru: `наб. Кутузова, 2`,
          en: `2 Kutuzov Embankment`,
          cn: `库图佐夫堤岸2号`,
        },
        type: `["entertainment"]`,
        icons: {
          car: {
            ru: `1 мин.`,
            en: `1 min`,
            cn: `1分钟`,
          },
          walk: {
            ru: `3 мин.`,
            en: `3 min`,
            cn: `3分钟`,
          },
        },
      },
    );
    const theatre = new CustomMarker( //михайловский театр
      new google.maps.LatLng(59.9374723, 30.3354879),
      map,
      {
        isTexted: true,
        markerClassName: `place__marker place__marker--folded place__marker--optional place__marker--theatre place__marker--hidden`,
        title: {
          ru: `Михайловский театр`,
          en: `Mikhaylovsky Theatre`,
          cn: `米哈伊洛夫斯基剧院`,
        },
        address: {
          ru: `пл. Искусств, 1`,
          en: `1 Pl. Iskusstv (Arts Sq.)`,
          cn: `艺术广场1`,
        },
        type: `["entertainment"]`,
        icons: {
          car: {
            ru: `10 мин.`,
            en: `10 min`,
            cn: `10分钟`,
          },
          walk: {
            ru: `20 мин.`,
            en: `20 min`,
            cn: `20分钟`,
          },
        },
      },
    );
    const hermitage = new CustomMarker(
      new google.maps.LatLng(59.939021, 30.312595),
      map,
      {
        isTexted: true,
        markerClassName: `place__marker place__marker--folded place__marker--optional place__marker--theatre`,
        title: {
          ru: `Государственный Эрмитаж`,
          en: `State Hermitage`,
          cn: `埃尔米塔什博物馆`,
        },
        address: {
          ru: `Дворцовая пл., 2`,
          en: `2 Dvortsovaya Pl. (Palace Sq.)`,
          cn: `冬宫广场2号`,
        },
        type: `["museum"]`,
        icons: {
          car: {
            ru: `7 мин.`,
            en: `7 min`,
            cn: `7分钟`,
          },
          walk: {
            ru: `23 мин.`,
            en: `23 min`,
            cn: `23分钟`,
          },
        },
      },
    );
    const castle = new CustomMarker( //Михайловский замок
      new google.maps.LatLng(59.939994, 30.338046),
      map,
      {
        isTexted: true,
        markerClassName: `place__marker place__marker--title-nowrap place__marker--folded place__marker--optional`,
        title: {
          ru: `Михайловский замок`,
          en: `Mikhailovsky Palace`,
          cn: `米哈伊洛夫斯基城堡`,
        },
        address: {
          ru: `Садовая ул., 2`,
          en: `2 Sadovaya St.`,
          cn: `花园路2号`,
        },
        type: `["museum"]`,
        icons: {
          car: {
            ru: `6 мин.`,
            en: `6 min`,
            cn: `6分钟`,
          },
          walk: {
            ru: `15 мин.`,
            en: `15 min`,
            cn: `15分钟`,
          },
        },
      },
    );
    const russianMuseum = new CustomMarker(
      new google.maps.LatLng(59.938592, 30.332221),
      map,
      {
        isTexted: true,
        markerClassName: `place__marker place__marker--folded place__marker--optional`,
        title: {
          ru: `Русский музей`,
          en: `Russian Museum`,
          cn: `俄罗斯博物馆`,
        },
        address: {
          ru: `Инженерная ул., 4`,
          en: `4 Inzhenernaya St.`,
          cn: `工程师路4号`,
        },
        type: `["museum"]`,
        icons: {
          car: {
            ru: `10 мин.`,
            en: `10 min`,
            cn: `10分钟`,
          },
          walk: {
            ru: `20 мин.`,
            en: `20 min`,
            cn: `20分钟`,
          },
        },
      },
    );
    const schoolEnglish = new CustomMarker(
      new google.maps.LatLng(59.944172, 30.360725),
      map,
      {
        isTexted: true,
        markerClassName: `place__marker place__marker--title-18 place__marker--folded place__marker--school place__marker--optional place__marker--hidden`,
        title: {
          ru: `Школа &#8470;&#160;183&#160;&#8212; школа с&#160;углубленным изучением английского языка`,
          en: `School 183 (with an extended English course)`,
          cn: `侧重于英语第183学校`,
        },
        address: {
          ru: `Кирочная ул., 28А`,
          en: `28A Kirochnaya St.`,
          cn: `基洛奇街28а号`,
        },
        type: `["schools"]`,
        icons: {
          car: {
            ru: `5 мин.`,
            en: `5 min`,
            cn: `5分钟`,
          },
          walk: {
            ru: `19 мин.`,
            en: `19 min`,
            cn: `19分钟`,
          },
        },
      },
    );
    const schoolPhysics = new CustomMarker(
      new google.maps.LatLng(59.94468, 30.351284),
      map,
      {
        isTexted: true,
        markerClassName: `place__marker place__marker--title-18 place__marker--folded place__marker--school place__marker--optional place__marker--hidden`,
        title: {
          ru: `Президентский физико &#8212; математический лицей&#160;&#8470;&#160;239`,
          en: `Presidentian Physics and Mathematics Lyceum 239`,
          cn: `总统物理数学第239文理中学`,
        },
        address: {
          ru: `Кирочная ул., 8Б`,
          en: `8B Kirochnaya St.`,
          cn: `基洛奇街8b号`,
        },
        type: `["schools"]`,
        icons: {
          car: {
            ru: `7 мин.`,
            en: `7 min`,
            cn: `7分钟`,
          },
          walk: {
            ru: `15 мин.`,
            en: `15 min`,
            cn: `15分钟`,
          },
        },
      },
    );
    const grammarSchool = new CustomMarker(
      new google.maps.LatLng(59.967986, 30.30302),
      map,
      {
        isTexted: true,
        markerClassName: `place__marker place__marker--folded place__marker--school place__marker--optional place__marker--hidden`,
        title: {
          ru: `Академическая гимназия&nbsp;№&nbsp;56`,
          en: `Academic Gymnasium 56`,
          cn: `第56文理学校`,
        },
        address: {
          ru: `Чкаловский пр., 35`,
          en: `35 Tchkalovsky Pr.`,
          cn: `契卡洛夫斯基大街35号`,
        },
        type: `["schools"]`,
        icons: {
          car: {
            ru: `14 мин.`,
            en: `14 min`,
            cn: `14分钟`,
          },
          walk: {
            ru: `50 мин.`,
            en: `50 min`,
            cn: `50分钟`,
          },
        },
      },
    );
    const restaurantFirst = new CustomMarker( //Ресторан Шаляпин
      new google.maps.LatLng(59.94708, 30.383441),
      map,
      {
        isTexted: true,
        markerClassName: `place__marker place__marker--folded place__marker--cafe place__marker--optional place__marker--hidden`,
        title: {
          ru: `Ресторан &#171;Шаляпин&#187;`,
          en: `Chaliapin Restaurant`,
          cn: `《沙利亚平》餐厅`,
        },
        address: {
          ru: `Тверская ул., 12/15`,
          en: `12/15 Tverskaya St.`,
          cn: `特维尔街12/15号`,
        },
        type: `["entertainment"]`,
        icons: {
          car: {
            ru: `6 мин.`,
            en: `6 min`,
            cn: `6分钟`,
          },
          walk: {
            ru: `30 мин.`,
            en: `30 min`,
            cn: `30分钟`,
          },
        },
      },
    );
    const restaurantSecond = new CustomMarker( //Ресторан Франческо
      new google.maps.LatLng(59.939731, 30.378056),
      map,
      {
        isTexted: true,
        markerClassName: `place__marker place__marker--folded place__marker--cafe place__marker--optional place__marker--hidden`,
        title: {
          ru: `Ресторан &#171;Франческо&#187;`,
          en: `Francesco Restaurant`,
          cn: `《弗朗切斯科》餐厅`,
        },
        address: {
          ru: `Суворовский пр., 47`,
          en: `47 Suvorovsky Pr.`,
          cn: `苏沃洛夫大街47号`,
        },
        type: `["entertainment"]`,
        icons: {
          car: {
            ru: `8 мин.`,
            en: `8 min`,
            cn: `8分钟`,
          },
          walk: {
            ru: `30 мин.`,
            en: `30 min`,
            cn: `30分钟`,
          },
        },
      },
    );
    const restaurantThird = new CustomMarker( //Ресторан Блок
      new google.maps.LatLng(59.945841, 30.368257),
      map,
      {
        isTexted: true,
        markerClassName: `place__marker place__marker--folded place__marker--cafe place__marker--optional place__marker--hidden`,
        title: {
          ru: `Ресторан &#171;Блок&#187;`,
          en: `Blok`,
          cn: `《勃洛克 》餐厅`,
        },
        address: {
          ru: `Потёмкинская ул., 4`,
          en: `4 Potemkinskaya St.`,
          cn: `波将金街4号`,
        },
        type: `["entertainment"]`,
        icons: {
          car: {
            ru: `5 мин.`,
            en: `5 min`,
            cn: `5分钟`,
          },
          walk: {
            ru: `20 мин.`,
            en: `20 min`,
            cn: `20分钟`,
          },
        },
      },
    );
    const restaurantFourth = new CustomMarker( //Ресторан Китайская Грамота
      new google.maps.LatLng(59.942593, 30.325786),
      map,
      {
        isTexted: true,
        markerClassName: `place__marker place__marker--folded place__marker--title-nowrap place__marker--cafe place__marker--optional place__marker--hidden`,
        title: {
          ru: `Ресторан &#171;Китайская грамота&#187;`,
          en: `Kitayskaya Gramota`,
          cn: `《食轩阁》中餐厅`,
        },
        address: {
          ru: `наб. реки Мойки, 7`,
          en: `7 Moika Embankment`,
          cn: `莫伊卡河滨河路7号`,
        },
        type: `["entertainment"]`,
        icons: {
          car: {
            ru: `5 мин.`,
            en: `5 min`,
            cn: `5分钟`,
          },
          walk: {
            ru: `15 мин.`,
            en: `15 min`,
            cn: `15分钟`,
          },
        },
      },
    );
    const restaurantFifth = new CustomMarker( //Ресторан КоКоКо
      new google.maps.LatLng(59.934949, 30.308759),
      map,
      {
        isTexted: true,
        markerClassName: `place__marker place__marker--folded place__marker--cafe place__marker--optional place__marker--hidden`,
        title: {
          ru: `Ресторан &#171;КоКоКо&#187;`,
          en: `KoKoKo`,
          cn: `《Cococo》餐厅`,
        },
        address: {
          ru: `Вознесенский пр., 6`,
          en: `6 Voznesensky Pr.`,
          cn: `沃兹涅先斯基大街6号`,
        },
        type: `["entertainment"]`,
        icons: {
          car: {
            ru: `20 мин.`,
            en: `20 min`,
            cn: `20分钟`,
          },
          walk: {
            ru: `30 мин.`,
            en: `30 min`,
            cn: `30分钟`,
          },
        },
      },
    );
    const restaurantSixth = new CustomMarker( //Ресторан Jerome
      new google.maps.LatLng(59.934176, 30.312857),
      map,
      {
        isTexted: true,
        markerClassName: `place__marker place__marker--folded place__marker--cafe place__marker--optional place__marker--hidden`,
        title: {
          ru: `Ресторан &#171;Jerome&#187;`,
          en: `Jerome`,
          cn: `《热罗姆》（Jerome）餐厅`,
        },
        address: {
          ru: `ул. Большая Морская, 25`,
          en: `25 Bolshaya Morskaya St.`,
          cn: `大海街25号`,
        },
        type: `["entertainment"]`,
        icons: {
          car: {
            ru: `15 мин.`,
            en: `15 min`,
            cn: `15分钟`,
          },
          walk: {
            ru: `30 мин.`,
            en: `30 min`,
            cn: `30分钟`,
          },
        },
      },
    );
    const restaurantSeventh = new CustomMarker( //Ресторан Volna Restaurant
      new google.maps.LatLng(59.95357, 30.329742),
      map,
      {
        isTexted: true,
        markerClassName: `place__marker place__marker--folded place__marker--cafe place__marker--optional place__marker--hidden`,
        title: {
          ru: `Ресторан<br>&#171;Volna Restaurant&#187;`,
          en: `Volna Restaurant`,
          cn: `波浪餐厅`,
        },
        address: {
          ru: `Петровская наб., 4`,
          en: `4 Petrovskaya Embankment`,
          cn: `彼得罗夫斯基沿岸4号`,
        },
        type: `["entertainment"]`,
        icons: {
          car: {
            ru: `10 мин.`,
            en: `10 min`,
            cn: `10分钟`,
          },
          walk: {
            ru: `20 мин.`,
            en: `20 min`,
            cn: `20分钟`,
          },
        },
      },
    );
    const restaurantEight = new CustomMarker( //Ресторан ТарТарБар
      new google.maps.LatLng(59.939934, 30.366328),
      map,
      {
        isTexted: true,
        markerClassName: `place__marker place__marker--folded place__marker--cafe place__marker--optional place__marker--hidden`,
        title: {
          ru: `Ресторан &#171;ТарТарБар&#187;`,
          en: `Tartarbar`,
          cn: `《Tartar》吧`,
        },
        address: {
          ru: `Виленский пер., 15`,
          en: `15 Vilensky Per.`,
          cn: `维连斯基巷15号`,
        },
        type: `["entertainment"]`,
        icons: {
          car: {
            ru: `10 мин.`,
            en: `10 min`,
            cn: `10分钟`,
          },
          walk: {
            ru: `25 мин.`,
            en: `25 min`,
            cn: `25分钟`,
          },
        },
      },
    );
    const restaurantNinth = new CustomMarker( //Ресторан Duo gastrobar
      new google.maps.LatLng(59.944155, 30.351183),
      map,
      {
        isTexted: true,
        markerClassName: `place__marker place__marker--folded place__marker--cafe place__marker--optional place__marker--hidden`,
        title: {
          ru: `Ресторан<br>&#171;Duo gastrobar&#187;`,
          en: `Duo Gastrobar`,
          cn: `《Duo》美食吧`,
        },
        address: {
          ru: `Кирочная ул., 8А`,
          en: `8A Kirochnaya St.`,
          cn: `基洛奇街8a`,
        },
        type: `["entertainment"]`,
        icons: {
          car: {
            ru: `10 мин.`,
            en: `10 min`,
            cn: `10分钟`,
          },
          walk: {
            ru: `15 мин.`,
            en: `15 min`,
            cn: `15分钟`,
          },
        },
      },
    );
    const russianGrammarSchool = new CustomMarker( //Российская гимназия при Государственном Русском музее
      new google.maps.LatLng(59.937126, 30.333857),
      map,
      {
        isTexted: true,
        markerClassName: `place__marker place__marker--title-18 place__marker--folded place__marker--optional place__marker--hidden`,
        title: {
          ru: `Российская гимназия <br>при&#160;Государственном<br>Русском&#160;музее`,
          en: `Russian Gymnasium<br>under the State Russian<br>Museum `,
          cn: `俄罗斯博物馆附属俄罗斯文理学校`,
        },
        address: {
          ru: `пл. Искусств, 2`,
          en: `2 Pl. Iskusstv (Arts Sq.)`,
          cn: `艺术广场2号`,
        },
        type: `["schools"]`,
        icons: {
          car: {
            ru: `10 мин.`,
            en: `10 min`,
            cn: `10分钟`,
          },
          walk: {
            ru: `15 мин.`,
            en: `15 min`,
            cn: `15分钟`,
          },
        },
      },
    );
    const pavlovGrammarSchool = new CustomMarker( //Гимназия 209 "Павловская гимназия"
      new google.maps.LatLng(59.93365, 30.35992),
      map,
      {
        isTexted: true,
        markerClassName: `place__marker place__marker--folded place__marker--optional place__marker--hidden`,
        title: {
          ru: `Гимназия 209<br>&#171;Павловская&#160;гимназия&#187;`,
          en: `Gymnasium 209,<br>Pavlovskaya (Paul) Gymnasium`,
          cn: `第209巴甫洛夫斯基文理学校`,
        },
        address: {
          ru: `ул. Восстания, 8A`,
          en: `8A Vosstania St.`,
          cn: `起义街8a号`,
        },
        type: `["schools"]`,
        icons: {
          car: {
            ru: `10 мин.`,
            en: `10 min`,
            cn: `10分钟`,
          },
          walk: {
            ru: `25 мин.`,
            en: `25 min`,
            cn: `25分钟`,
          },
        },
      },
    );
    const petriSchool = new CustomMarker( //Школа 222 Петришуле
      new google.maps.LatLng(59.935895, 30.324213),
      map,
      {
        isTexted: true,
        markerClassName: `place__marker place__marker--folded place__marker--optional place__marker--hidden`,
        title: {
          ru: `Школа&#160;222&#160;&#171;Петришуле&#187;`,
          en: `School 222 Petrischule`,
          cn: `第222彼得学校`,
        },
        address: {
          ru: `Невский пр., 22-24`,
          en: `22-24 Nevsky Pr.`,
          cn: `涅瓦大街22-24`,
        },
        type: `["schools"]`,
        icons: {
          car: {
            ru: `15 мин.`,
            en: `15 min`,
            cn: `15分钟`,
          },
          walk: {
            ru: `20 мин.`,
            en: `20 min`,
            cn: `20分钟`,
          },
        },
      },
    );
    const planetKids = new CustomMarker( // PlanetKids частный детский сад
      new google.maps.LatLng(59.956986, 30.322985),
      map,
      {
        isTexted: true,
        markerClassName: `place__marker place__marker--folded place__marker--optional place__marker--hidden`,
        title: {
          ru: `&#171;Planet kids&#187; частный<br>детский&#160;сад`,
          en: `Planet Kids (private kindergarten)`,
          cn: `Planet kids私立幼儿园`,
        },
        address: {
          ru: `Крестьянский пер., 5`,
          en: `5 Krestyanky Per.`,
          cn: `克列斯基杨斯基巷5号`,
        },
        type: `["schools"]`,
        icons: {
          car: {
            ru: `10 мин.`,
            en: `10 min`,
            cn: `10分钟`,
          },
          walk: {
            ru: `20 мин.`,
            en: `20 min`,
            cn: `20分钟`,
          },
        },
      },
    );
    const mirt = new CustomMarker( // Мирт
      new google.maps.LatLng(59.941224, 30.342874),
      map,
      {
        isTexted: true,
        markerClassName: `place__marker place__marker--folded place__marker--optional place__marker--hidden`,
        title: {
          ru: `Частная&#160;школа&#160;&#171;МИРТ&#187;`,
          en: `Mirt School`,
          cn: `Mirt私立学校`,
        },
        address: {
          ru: `наб. реки Фонтанки, 18-г`,
          en: `18-g Fontanka Embankment`,
          cn: `丰坦卡河滨河路18-g号`,
        },
        type: `["schools"]`,
        icons: {
          car: {
            ru: `1 мин.`,
            en: `1 min`,
            cn: `1分钟`,
          },
          walk: {
            ru: `5 мин.`,
            en: `5 min`,
            cn: `5分钟`,
          },
        },
      },
    );
    const akcent = new CustomMarker( // AKCent American kids Center
      new google.maps.LatLng(59.946658, 30.358464),
      map,
      {
        isTexted: true,
        markerClassName: `place__marker place__marker--title-18 place__marker--folded place__marker--optional place__marker--hidden`,
        title: {
          ru: `&#171;AKCent&#187; American&#160;kids<br>Center`,
          en: `AKCent American Kids Center`,
          cn: `AKCent美式私立幼儿园`,
        },
        address: {
          ru: `ул. Чайковского, 38`,
          en: `38 Tchaikovsky St.`,
          cn: `柴可夫斯基街38号`,
        },
        type: `["schools"]`,
        icons: {
          car: {
            ru: `5 мин.`,
            en: `5 min`,
            cn: `5分钟`,
          },
          walk: {
            ru: `20 мин.`,
            en: `20 min`,
            cn: `20分钟`,
          },
        },
      },
    );
    const maryJane = new CustomMarker( // Британский клубный детский сад Mary Jane
      new google.maps.LatLng(59.942235, 30.370749),
      map,
      {
        isTexted: true,
        markerClassName: `place__marker place__marker--title-18 place__marker--title-nowrap place__marker--folded place__marker--optional place__marker--hidden`,
        title: {
          ru: `Британский клубный<br>детский сад &#171;Mary Jane&#187;`,
          en: `Mary Jane British<br>Nursery School`,
          cn: `Mary Jane英国俱乐部幼儿园`,
        },
        address: {
          ru: `Парадная ул., 3/2А`,
          en: `3/2A Paradnaya St.`,
          cn: `前门街3/2a号`,
        },
        type: `["schools"]`,
        icons: {
          car: {
            ru: `10 мин.`,
            en: `10 min`,
            cn: `10分钟`,
          },
          walk: {
            ru: `25 мин.`,
            en: `25 min`,
            cn: `25分钟`,
          },
        },
      },
    );
    const academicDramaticTheatre = new CustomMarker( // Академический драматический театр имени В. Ф. Комиссаржевской
      new google.maps.LatLng(59.93604, 30.33501),
      map,
      {
        isTexted: true,
        markerClassName: `place__marker place__marker--title-18 place__marker--title-nowrap place__marker--folded place__marker--optional place__marker--hidden`,
        title: {
          ru: `Академический<br>драматический театр<br>имени В. Ф. Комиссаржевской`,
          en: `V. F. Komissarzhevskaya<br>Academic Drama Theatre`,
          cn: `科米萨尔热夫斯基模范话剧院`,
        },
        address: {
          ru: `Итальянская ул., 19`,
          en: `19 Italianskaya St.`,
          cn: `意大利街19号`,
        },
        type: `["entertainment"]`,
        icons: {
          car: {
            ru: `10 мин.`,
            en: `10 min`,
            cn: `10分钟`,
          },
          walk: {
            ru: `15 мин.`,
            en: `15 min`,
            cn: `15分钟`,
          },
        },
      },
    );
    const eifmanTheatre = new CustomMarker( // Академический театр балета Бориса Эйфмана
      new google.maps.LatLng(59.943435, 30.343309),
      map,
      {
        isTexted: true,
        markerClassName: `place__marker place__marker--title-18 place__marker--title-nowrap place__marker--folded place__marker--optional place__marker--hidden`,
        title: {
          ru: `Санкт-Петербургский<br>государственный<br>академический театр<br>балета Бориса<br>Эйфмана`,
          en: `Boris Eifman State<br>Academic Ballet Theatre of<br>St Petersburg `,
          cn: `俄罗斯圣彼得堡艾夫曼芭蕾舞模范剧院`,
        },
        address: {
          ru: `Гагаринская ул., 32`,
          en: `32 Gagarinskaya St.`,
          cn: `加加林街32号`,
        },
        type: `["entertainment"]`,
        icons: {
          car: {
            ru: `5 мин.`,
            en: `5 min`,
            cn: `5分钟`,
          },
          walk: {
            ru: `15 мин.`,
            en: `15 min`,
            cn: `15分钟`,
          },
        },
      },
    );
    const hermitageTheatre = new CustomMarker( // Эрмитажный театр
      new google.maps.LatLng(59.94217, 30.316068),
      map,
      {
        isTexted: true,
        markerClassName: `place__marker place__marker--title-nowrap place__marker--folded place__marker--optional place__marker--hidden`,
        title: {
          ru: `Эрмитажный театр`,
          en: `Hermitage Theatre`,
          cn: `冬宫剧院`,
        },
        address: {
          ru: `Дворцовая наб., 34`,
          en: `34 Dvortsovaya Embankment (Palace Emb.)`,
          cn: `宫廷滨河路34号`,
        },
        type: `["entertainment"]`,
        icons: {
          car: {
            ru: `15 мин.`,
            en: `15 min`,
            cn: `15分钟`,
          },
          walk: {
            ru: `15 мин.`,
            en: `15 min`,
            cn: `15分钟`,
          },
        },
      },
    );
    const lensovetaTheatre = new CustomMarker( // Театр Ленсовета
      new google.maps.LatLng(59.92923, 30.347602),
      map,
      {
        isTexted: true,
        markerClassName: `place__marker place__marker--title-18 place__marker--title-nowrap place__marker--folded place__marker--optional place__marker--hidden`,
        title: {
          ru: `Санкт-Петербургский<br>академический театр<br>имени Ленсовета`,
          en: `Lensoviet Academic<br>Theatre of St Petersburg`,
          cn: `列宁格勒苏维埃圣彼得堡模范剧院`,
        },
        address: {
          ru: `Владимирский пр-кт, 12`,
          en: `12 Vladimirsky Pr.`,
          cn: `弗拉基米尔大街12号`,
        },
        type: `["entertainment"]`,
        icons: {
          car: {
            ru: `10 мин.`,
            en: `10 min`,
            cn: `10分钟`,
          },
          walk: {
            ru: `25 мин.`,
            en: `25 min`,
            cn: `25分钟`,
          },
        },
      },
    );
    const tovstonogovaTheatre = new CustomMarker( // БДТ имени Г. А. Товстоногова
      new google.maps.LatLng(59.927581, 30.330572),
      map,
      {
        isTexted: true,
        markerClassName: `place__marker place__marker--title-nowrap place__marker--folded place__marker--optional place__marker--hidden`,
        title: {
          ru: `БДТ имени Г. А.<br>Товстоногова`,
          en: `G. A. Tovstonogov<br>Bolshoi Drama Theatre`,
          cn: `托夫斯托诺戈夫大话剧院`,
        },
        address: {
          ru: `наб. реки Фонтанки, 65`,
          en: `65 Fontanka Embankment`,
          cn: `丰坦卡河滨河路65号`,
        },
        type: `["entertainment"]`,
        icons: {
          car: {
            ru: `15 мин.`,
            en: `15 min`,
            cn: `15分钟`,
          },
          walk: {
            ru: `30 мин.`,
            en: `30 min`,
            cn: `30分钟`,
          },
        },
      },
    );
    const stadium = new CustomMarker( // Стадион Санкт-Петербург
      new google.maps.LatLng(59.973087, 30.220191),
      map,
      {
        isTexted: true,
        markerClassName: `place__marker place__marker--title-nowrap place__marker--folded place__marker--optional place__marker--hidden`,
        title: `Стадион &#171;Санкт-Петербург&#187;`,
        address: `Футбольная ал., 1`,
        type: `["entertainment"]`,
        icons: {
          car: `21 мин.`,
          walk: `1 час 40 мин.`,
        },
      },
    );
    const russianEthnography = new CustomMarker( // Российский этнографический музей
      new google.maps.LatLng(59.937769, 30.334755),
      map,
      {
        isTexted: true,
        markerClassName: `place__marker place__marker--title-nowrap place__marker--folded place__marker--optional`,
        title: {
          ru: `Российский<br>этнографический музей`,
          en: `Russian Ethnographic Museum`,
          cn: `俄罗斯民族博物馆`,
        },
        address: {
          ru: `Инженерная ул., 4/1`,
          en: `4/1 Inzhenernaya St.`,
          cn: `工程师街 4/1号`,
        },
        type: `["museum"]`,
        icons: {
          car: {
            ru: `10 мин.`,
            en: `10 min`,
            cn: `10分钟`,
          },
          walk: {
            ru: `15 мин.`,
            en: `15 min`,
            cn: `15分钟`,
          },
        },
      },
    );
    const politicHistory = new CustomMarker( // Государственный Музей политической истории России
      new google.maps.LatLng(59.954582, 30.325119),
      map,
      {
        isTexted: true,
        markerClassName: `place__marker place__marker--title-nowrap place__marker--title-18 place__marker--folded place__marker--optional`,
        title: {
          ru: `Государственный музей<br>политической истории<br>России`,
          en: `State Museum of Political<br>History of Russia`,
          cn: `俄罗斯历史政治博物`,
        },
        address: {
          ru: `ул. Куйбышева, 2-4`,
          en: `2-4 Kuybyshev St.`,
          cn: `古比雪夫街2-4号`,
        },
        type: `["museum"]`,
        icons: {
          car: {
            ru: `10 мин.`,
            en: `10 min`,
            cn: `10分钟`,
          },
          walk: {
            ru: `20 мин.`,
            en: `20 min`,
            cn: `20分钟`,
          },
        },
      },
    );
    const spas = new CustomMarker( // Спас на Крови
      new google.maps.LatLng(59.941104, 30.329454),
      map,
      {
        isTexted: true,
        markerClassName: `place__marker place__marker--title-nowrap place__marker--folded place__marker--optional`,
        title: {
          ru: `Спас на Крови`,
          en: `Savior on Spilled Blood`,
          cn: `滴血救世主大教堂`,
        },
        address: {
          ru: `наб. канала Грибоедова, 2Б`,
          en: `2B Griboyedov Canal Embankment`,
          cn: `格里鲍里耶夫河岸2b号`,
        },
        type: `["museum"]`,
        icons: {
          car: {
            ru: `5 мин.`,
            en: `5 min`,
            cn: `5分钟`,
          },
          walk: {
            ru: `15 мин.`,
            en: `15 min`,
            cn: `15分钟`,
          },
        },
      },
    );
    const cathedral = new CustomMarker( // Казанский кафедральный собор
      new google.maps.LatLng(59.934225, 30.324516),
      map,
      {
        isTexted: true,
        markerClassName: `place__marker place__marker--title-nowrap place__marker--folded place__marker--optional`,
        title: {
          ru: `Казанский<br>кафедральный собор`,
          en: `Cathedral<br>of Our Lady of Kazan`,
          cn: `喀山大教堂`,
        },
        address: {
          ru: `Казанская пл., 2`,
          en: `2 Kazanskaya Sq.`,
          cn: `喀山广场2号`,
        },
        type: `["museum"]`,
        icons: {
          car: {
            ru: `15 мин.`,
            en: `15 min`,
            cn: `15分钟`,
          },
          walk: {
            ru: `20 мин.`,
            en: `20 min`,
            cn: `20分钟`,
          },
        },
      },
    );
    const fabergeMuseum = new CustomMarker( // Музей Фаберже
      new google.maps.LatLng(59.934745, 30.342846),
      map,
      {
        isTexted: true,
        markerClassName: `place__marker place__marker--title-nowrap place__marker--folded place__marker--optional`,
        title: {
          ru: `Музей Фаберже`,
          en: `Faberge Museum`,
          cn: `法贝热博物馆`,
        },
        address: {
          ru: `наб. реки Фонтанки, 21`,
          en: `21 Fontanka Embankment`,
          cn: `丰坦卡河滨河路21号`,
        },
        type: `["museum"]`,
        icons: {
          car: {
            ru: `10 мин.`,
            en: `10 min`,
            cn: `10分钟`,
          },
          walk: {
            ru: `20 мин.`,
            en: `20 min`,
            cn: `20分钟`,
          },
        },
      },
    );
    const peterPavelsFortress = new CustomMarker( // Петропавловская крепость
      new google.maps.LatLng(59.950003, 30.314505),
      map,
      {
        isTexted: true,
        markerClassName: `place__marker place__marker--title-nowrap place__marker--folded place__marker--optional`,
        title: {
          ru: `Петропавловская<br>крепость`,
          en: `Peter and Paul Fortress`,
          cn: `彼得保罗要塞`,
        },
        address: {
          ru: `Заячий остров`,
          en: `Zayachy Island`,
          cn: `兔子岛`,
        },
        type: `["museum"]`,
        icons: {
          car: {
            ru: `10 мин.`,
            en: `10 min`,
            cn: `10分钟`,
          },
          walk: {
            ru: `20 мин.`,
            en: `20 min`,
            cn: `20分钟`,
          },
        },
      },
    );
    //TODO: move info about markers to separate file, create mapper

    markers.push(summerGarden);
    markers.push(theatre);
    markers.push(hermitage);
    markers.push(castle);
    markers.push(russianMuseum);
    markers.push(schoolEnglish);
    markers.push(schoolPhysics);
    markers.push(grammarSchool);
    markers.push(restaurantFirst);
    markers.push(restaurantSecond);
    markers.push(restaurantThird);
    markers.push(restaurantFourth);
    markers.push(restaurantFifth);
    markers.push(restaurantSixth);
    markers.push(restaurantSeventh);
    markers.push(restaurantEight);
    markers.push(restaurantNinth);
    markers.push(mainMarker);
    markers.push(russianGrammarSchool);
    markers.push(pavlovGrammarSchool);
    markers.push(petriSchool);
    markers.push(planetKids);
    markers.push(mirt);
    markers.push(akcent);
    markers.push(maryJane);
    markers.push(academicDramaticTheatre);
    markers.push(eifmanTheatre);
    markers.push(lensovetaTheatre);
    markers.push(tovstonogovaTheatre);
    markers.push(hermitageTheatre);
    markers.push(stadium);
    markers.push(politicHistory);
    markers.push(spas);
    markers.push(cathedral);
    markers.push(fabergeMuseum);
    markers.push(peterPavelsFortress);
    markers.push(russianEthnography);

    initToggle(markers, locale);
  };

  try {
    initMap();
  } catch (error) {
    console.error(error);
  }

  function generateCustomMarker() {
    class CustomMarker extends google.maps.OverlayView {
      constructor(coords, map, options) {
        super();

        this.latlng = coords;
        this.options = options;
        this.type = null;
        this.map = map;
        this.setMap(map);
      }

      getMap = () => {
        return this.map;
      };

      draw = () => {
        const mainMap = this.getMap();
        const position = this.getPosition();
        let div = this.div;
        let title;
        let address;
        let content;
        let wrap;

        if (!div) {
          div = this.div = document.createElement(`div`);
          wrap = document.createElement(`div`);
          title =
            this.options &&
            this.options.isTexted &&
            document.createElement(`p`);
          address =
            this.options &&
            this.options.isTexted &&
            document.createElement(`p`);

          div.className = this.options.markerClassName;
          wrap.className = `place__marker-wrap`;
          div.style.position = `absolute`;
          div.style.cursor = `pointer`;

          if (this.options.type) {
            this.type = this.options.type;
            div.dataset.type = this.options.type;
          }

          let isMapZoomed = false;

          google.maps.event.addDomListener(div, "click", (event) => {
            const isFolded = div.classList.contains(`place__marker--folded`);
            const isMainMarker = div.classList.contains(`place__marker--main`);
            const mainMarker = document.querySelector(`.place__marker--main`);
            const markers = [
              ...document.querySelectorAll(
                `.place__marker:not(.place__marker--main)`,
              ),
            ];
            const isOpenedMarkerExist = markers.some(
              (marker) => !marker.classList.contains(`place__marker--folded`),
            );
            const markerZoom = 14;

            if (!isMainMarker && isFolded) {
              mainMarker.classList.add(`place__marker--folded`);
            }

            if (isMobile) {
              //TODO: optimize condition
              if (isFolded) {
                if (!isOpenedMarkerExist) {
                  mainMap.setZoom(markerZoom);
                  mainMap.panTo(position);
                }
                markers.forEach((marker) =>
                  marker.classList.add(`place__marker--folded`),
                );
                div.classList.remove(`place__marker--folded`);
              } else {
                mainMap.setZoom(11.5);
                mainMap.panTo(centerCoords.DESKTOP_CENTER);
                div.classList.add(`place__marker--folded`);
              }
              isMapZoomed = !isMapZoomed;
            } else {
              if (isFolded) {
                markers.forEach((marker) =>
                  marker.classList.add(`place__marker--folded`),
                );
                div.classList.remove(`place__marker--folded`);
              } else {
                div.classList.add(`place__marker--folded`);
              }
            }

            google.maps.event.trigger(self, "click");
          });

          const panes = this.getPanes();
          panes.overlayImage.appendChild(div);

          if (this.options.isTexted) {
            title.innerHTML = this.options.title[locale];
            address.innerHTML = this.options.address[locale];
            title.className = `place__title`;
            address.className = `place__address`;
          }

          wrap.appendChild(title);
          wrap.appendChild(address);
          div.appendChild(wrap);
        }

        if (this.options.icons && wrap) {
          const icons = document.createElement(`div`);
          const car = document.createElement(`div`);
          const walk = document.createElement(`div`);

          icons.className = `place__icons`;
          walk.className = `place__icon place__icon--walk`;
          car.className = `place__icon place__icon--car`;

          car.innerHTML = this.options.icons.car[locale];
          walk.innerHTML = this.options.icons.walk[locale];

          icons.appendChild(car);
          icons.appendChild(walk);
          wrap.appendChild(icons);
        }

        const point = this.getProjection().fromLatLngToDivPixel(this.latlng);

        if (point) {
          div.style.left = point.x - 12 + `px`;
          div.style.top = point.y - 11 + `px`;
        }
      };

      remove = () => {
        if (this.div) {
          this.div.parentNode.removeChild(this.div);
          this.div = null;
        }
      };

      getPosition = () => {
        return this.latlng;
      };
    }

    return CustomMarker;
  }
};
